module.exports = __webpack_public_path__ + "img/Anhänger.bb3813b1.svg";